import React from "react";
import { TransactionMatchType } from "@common/types/transactionMatchType";
import { formatFilterLabelText } from "./formatFilterLabel";

interface MatchedFilterLabelProps {
    filters: {
        matchTypes?: TransactionMatchType[];
    };
}

const MATCH_TYPE_LABELS: Record<TransactionMatchType, string> = {
    [TransactionMatchType.TRANSACTION]: "Transaction match",
    [TransactionMatchType.INVOICE]: "Invoice match",
    [TransactionMatchType.BILL]: "Bill match",
    [TransactionMatchType.NONE]: "No match",
    [TransactionMatchType.SUGGESTED_INVOICE]: "Suggested invoice match",
    [TransactionMatchType.SUGGESTED_BILL]: "Suggested bill match",
};

// Stable presentation order — independent of toggle order so the chip is
// deterministic when users select the same set in different orders.
const ORDER: TransactionMatchType[] = [
    TransactionMatchType.TRANSACTION,
    TransactionMatchType.INVOICE,
    TransactionMatchType.BILL,
    TransactionMatchType.NONE,
    TransactionMatchType.SUGGESTED_INVOICE,
    TransactionMatchType.SUGGESTED_BILL,
];

export const MatchedFilterLabel: React.FC<MatchedFilterLabelProps> = ({
    filters: { matchTypes },
}) => {
    if (!matchTypes || matchTypes.length === 0) {
        return null;
    }
    const selected = new Set(matchTypes);
    const parts = ORDER.filter((type) => selected.has(type)).map(
        (type) => MATCH_TYPE_LABELS[type],
    );
    return <>{formatFilterLabelText(parts, "Match types")}</>;
};
